import { useContext } from 'react';
import { GlobalContext } from '../../mainv3/contexts/global';

export const useViewportState = () => {
  const { viewport } = useContext(GlobalContext);
  return viewport;
};
